import { Component, Inject } from '@angular/core';
import Env from '@ridango/core/env';

@Component({
    templateUrl: './account-cards-parent-page.component.html',
    styleUrls: ['./account-cards-parent-page.component.scss']
})
export class AccountCardsParentPageComponent {
    constructor(@Inject('ENV') public env: Env) {}
}
